import React from 'react'
import {QuoteDetailListTable} from "../Component/QuoteDetailListTable";

const NoBidTabList = (props) => {
    return (
        <div>
            <QuoteDetailListTable {...props}/>
        </div>
    )
};

export default NoBidTabList